import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import Button from '../../../../../../components/global/Button';
import SeparatedPinField from '../../../../../../components/global/PinField/SeparatedPinField';
import { EVENTS } from '../../../../../../services/gtag/constants';
import useGtagManualTracking from '../../../../../../services/gtag/useGtagManualTracking';

const propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  handleSubmit: PropTypes.func.isRequired,
  handleChange: PropTypes.func.isRequired,
  errors: PropTypes.object,
  values: PropTypes.object.isRequired,
  onPinCodeResend: PropTypes.func.isRequired,
};

const ShutterbugEmailPinVerify = ({
  className,
  loading,
  handleSubmit,
  handleChange,
  errors,
  onPinCodeResend,
  values,
}) => {
  const { onTrackEvent } = useGtagManualTracking();
  const classes = classNames({
    [className]: !!className,
  });

  useEffect(() => {
    if (values.code?.length === 4) {
      onTrackEvent({
        event: EVENTS.CLICK_VERIFY_PIN_CODE,
        data: { page_title: 'Complete Consumer Pin Auth' },
      });
      handleSubmit();
    }
  }, [values.code]);

  return (
    <div className={classes}>
      <form onSubmit={handleSubmit}>
        <p className="registration-pin-heading">Enter your verification PIN</p>

        {errors?.code && (
          <p className="registration-pin-error">{errors.code}</p>
        )}

        <div className="mb-3">
          <SeparatedPinField
            onChange={value => {
              handleChange({
                target: {
                  name: 'code',
                  value,
                },
              });
            }}
          />
        </div>

        <div className="text-center mt-3 text-sm">
          Didn&apos;t receive the code?{' '}
          <Button
            type="button"
            btnStyle="link"
            btnSize="sm"
            disabled={loading}
            onClick={() => onPinCodeResend(values)}
          >
            Resend code
          </Button>
        </div>
      </form>
    </div>
  );
};

ShutterbugEmailPinVerify.propTypes = propTypes;

export default ShutterbugEmailPinVerify;
